import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserPreferredLanguage } from '@app/launchers/models/user-preferred-language';
import { RuntimeConfig } from '@app/runtime-config';
import { BaseApiService } from '@app/shared/http-service/base-api.service';
import { ApiResponse } from '@app/shared/models/api-response';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AssessmentUserApiService extends BaseApiService {

	constructor (http: HttpClient, runtimeConfig: RuntimeConfig) {
		super(http, runtimeConfig);
	}

	getUserPreferredLanguageByUserAssessmentId (userAssessmentId: string): Observable<ApiResponse<UserPreferredLanguage>> {
		return this.get<ApiResponse<UserPreferredLanguage>>(`${ this.baseUrl }/${ userAssessmentId }`);
	}

	get baseUrl (): string {
		return `${ this.runtimeConfig.appSettings.apiEndpoints.assessmentService.url }/${ this.runtimeConfig.appSettings.apiEndpoints.assessmentService.version }/user`;
	}
}